import React from 'react';
import { useXScale } from '@mui/x-charts';
import WindMarker from './WindMarker';
import { resample } from '../utils/timeseries';
import { windFormatter } from '../utils/format';

function getTextDirection(angle) {
  if (angle >= 337.5 || angle < 22.5) return 'N';
  if (angle >= 22.5 && angle < 67.5) return 'NE';
  if (angle >= 67.5 && angle < 112.5) return 'E';
  if (angle >= 112.5 && angle < 157.5) return 'SE';
  if (angle >= 157.5 && angle < 202.5) return 'S';
  if (angle >= 202.5 && angle < 247.5) return 'SW';
  if (angle >= 247.5 && angle < 292.5) return 'W';
  if (angle >= 292.5 && angle < 337.5) return 'NW';
  return '';
}

export default function WindOverlay({ forecast, label = 'direction', y = 30 }) {
  const directions = resample(forecast.data.windDirection, forecast.times);
  const speeds = resample(forecast.data.windSpeed, forecast.times);

  const xScale = useXScale();

  return (
    <g>
      {directions.map((datum, index) => {
        const x = xScale(datum.time);

        return (
          <>
            <WindMarker x={x} y={y} direction={datum.value} />
            <text
              x={x}
              y={y + 22}
              textAnchor="middle"
              fontSize={12}
              fill="black"
            >
              {label === 'direction'
                ? getTextDirection(datum.value)
                : windFormatter.format(speeds[index].value)}
            </text>
          </>
        );
      })}
    </g>
  );
}
